import CustomScrollBars from './CustomScroll';

export default CustomScrollBars;
